/**
 * Generated from FlyingGameLayout.fla
 */
export function FlyingGameLayout(this: IFlyingGameLayout) {
	const upButton = this.upButton;
	FlyingGameLayout_upButton.call(this.upButton);
	upButton.x = 409;
	upButton.y = 732.75;
	upButton.width = 151.50;
	upButton.height = 95.50;
	if (upButton.onLayout) upButton.onLayout();
	const downButton = this.downButton;
	FlyingGameLayout_downButton.call(this.downButton);
	downButton.x = 617;
	downButton.y = 732.75;
	downButton.width = 151.50;
	downButton.height = 95.50;
	if (downButton.onLayout) downButton.onLayout();
	const lanesBg = this.lanesBg;
	FlyingGameLayout_lanesBg.call(this.lanesBg);
	lanesBg.x = 512;
	lanesBg.y = 410;
	lanesBg.width = 1664.00;
	lanesBg.height = 434.50;
	if (lanesBg.onLayout) lanesBg.onLayout();
	const progressBarBg = this.progressBarBg;
	FlyingGameLayout_progressBarBg.call(this.progressBarBg);
	progressBarBg.x = 512;
	progressBarBg.y = 114.7;
	progressBarBg.width = 427.00;
	progressBarBg.height = 58.00;
	if (progressBarBg.onLayout) progressBarBg.onLayout();
	const progressBarFill = this.progressBarFill;
	FlyingGameLayout_progressBarFill.call(this.progressBarFill);
	progressBarFill.x = 512;
	progressBarFill.y = 114.25;
	progressBarFill.width = 419.00;
	progressBarFill.height = 49.00;
	if (progressBarFill.onLayout) progressBarFill.onLayout();
	const progressBarStartIcon = this.progressBarStartIcon;
	FlyingGameLayout_progressBarStartIcon.call(this.progressBarStartIcon);
	progressBarStartIcon.x = 305;
	progressBarStartIcon.y = 107;
	progressBarStartIcon.width = 122.00;
	progressBarStartIcon.height = 80.00;
	if (progressBarStartIcon.onLayout) progressBarStartIcon.onLayout();
	const progressBarRestStopMarkerVisited = this.progressBarRestStopMarkerVisited;
	FlyingGameLayout_progressBarRestStopMarkerVisited.call(this.progressBarRestStopMarkerVisited);
	progressBarRestStopMarkerVisited.x = 430.95;
	progressBarRestStopMarkerVisited.y = 85.75;
	progressBarRestStopMarkerVisited.width = 57.00;
	progressBarRestStopMarkerVisited.height = 77.00;
	if (progressBarRestStopMarkerVisited.onLayout) progressBarRestStopMarkerVisited.onLayout();
	const progressBarRestStopMarker = this.progressBarRestStopMarker;
	FlyingGameLayout_progressBarRestStopMarker.call(this.progressBarRestStopMarker);
	progressBarRestStopMarker.x = 576.7;
	progressBarRestStopMarker.y = 85.75;
	progressBarRestStopMarker.width = 57.00;
	progressBarRestStopMarker.height = 77.00;
	if (progressBarRestStopMarker.onLayout) progressBarRestStopMarker.onLayout();
	const progressBarDestinationIcon = this.progressBarDestinationIcon;
	FlyingGameLayout_progressBarDestinationIcon.call(this.progressBarDestinationIcon);
	progressBarDestinationIcon.x = 723.25;
	progressBarDestinationIcon.y = 108;
	progressBarDestinationIcon.width = 124.00;
	progressBarDestinationIcon.height = 105.50;
	if (progressBarDestinationIcon.onLayout) progressBarDestinationIcon.onLayout();
	return this;
}
function FlyingGameLayout_upButton(this: IFlyingGameLayout_upButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flyinggame-arrow-up-btn.png", 0.502, 1.000);
	return this;
}
function FlyingGameLayout_downButton(this: IFlyingGameLayout_downButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flyinggame-arrow-down-btn.png", 0.502, 1.000);
	return this;
}
function FlyingGameLayout_lanesBg(this: IFlyingGameLayout_lanesBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flyinggame-flight-lanes@2x.png", 0.500, 0.501);
	return this;
}
function FlyingGameLayout_progressBarBg(this: IFlyingGameLayout_progressBarBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flyinggame-progress-bar-emptyl.png", 0.500, 0.500);
	return this;
}
function FlyingGameLayout_progressBarFill(this: IFlyingGameLayout_progressBarFill) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flyinggame-progress-bar-full.png", 0.500, 0.500);
	return this;
}
function FlyingGameLayout_progressBarStartIcon(this: IFlyingGameLayout_progressBarStartIcon) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-startimg.png", 0.500, 0.500);
	return this;
}
function FlyingGameLayout_progressBarRestStopMarkerVisited(this: IFlyingGameLayout_progressBarRestStopMarkerVisited) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-checkpoint.png", 0.500, 1.000);
	return this;
}
function FlyingGameLayout_progressBarRestStopMarker(this: IFlyingGameLayout_progressBarRestStopMarker) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-checkpoint.png", 0.500, 1.000);
	return this;
}
function FlyingGameLayout_progressBarDestinationIcon(this: IFlyingGameLayout_progressBarDestinationIcon) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-endimg.png", 0.500, 0.502);
	return this;
}
interface IFlyingGameLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IFlyingGameLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IFlyingGameLayoutSprite extends IFlyingGameLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IFlyingGameLayoutText extends IFlyingGameLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IFlyingGameLayoutPolygon extends Array<number> {
}
interface IFlyingGameLayout {
	readonly upButton: IFlyingGameLayout_upButton;
	readonly downButton: IFlyingGameLayout_downButton;
	readonly lanesBg: IFlyingGameLayout_lanesBg;
	readonly progressBarBg: IFlyingGameLayout_progressBarBg;
	readonly progressBarFill: IFlyingGameLayout_progressBarFill;
	readonly progressBarStartIcon: IFlyingGameLayout_progressBarStartIcon;
	readonly progressBarRestStopMarkerVisited: IFlyingGameLayout_progressBarRestStopMarkerVisited;
	readonly progressBarRestStopMarker: IFlyingGameLayout_progressBarRestStopMarker;
	readonly progressBarDestinationIcon: IFlyingGameLayout_progressBarDestinationIcon;
}
interface IFlyingGameLayout_upButton extends IFlyingGameLayoutSprite {
}
interface IFlyingGameLayout_downButton extends IFlyingGameLayoutSprite {
}
interface IFlyingGameLayout_lanesBg extends IFlyingGameLayoutSprite {
}
interface IFlyingGameLayout_progressBarBg extends IFlyingGameLayoutSprite {
}
interface IFlyingGameLayout_progressBarFill extends IFlyingGameLayoutSprite {
}
interface IFlyingGameLayout_progressBarStartIcon extends IFlyingGameLayoutSprite {
}
interface IFlyingGameLayout_progressBarRestStopMarkerVisited extends IFlyingGameLayoutSprite {
}
interface IFlyingGameLayout_progressBarRestStopMarker extends IFlyingGameLayoutSprite {
}
interface IFlyingGameLayout_progressBarDestinationIcon extends IFlyingGameLayoutSprite {
}
